export default function maintenance({ next }) {
  return next();
}
